import {PARAMS_FRONTEND_ROUNDING_AND_FORMATTING} from '../../constants/pricerTable'

export const roundAndFormat = (value,field) => {
    let fieldKey = field?.replace('bid','premium').replace('ask','premium');
    if(!(fieldKey in PARAMS_FRONTEND_ROUNDING_AND_FORMATTING)) return value;
    let returnValue = value;
    const roundedTo = PARAMS_FRONTEND_ROUNDING_AND_FORMATTING[fieldKey].roundedTo;
    const formattedTo = PARAMS_FRONTEND_ROUNDING_AND_FORMATTING[fieldKey].formattedTo;
    const showMinDecimals = 'showMinDecimals' in PARAMS_FRONTEND_ROUNDING_AND_FORMATTING[fieldKey];
    returnValue = Math.round(value * Math.pow(10, Number(roundedTo))) / Math.pow(10, Number(roundedTo))
    returnValue = Number(returnValue).toFixed(formattedTo);
    if(showMinDecimals) returnValue = Number(returnValue);
    return returnValue;
}


const mergeNestedObjects = (prev, incoming) => {
  if (incoming == null || typeof incoming !== "object" || Array.isArray(incoming)) {
    return prev;
  }
  const base = prev && typeof prev === "object" && !Array.isArray(prev) ? prev : {};
  return { ...base, ...incoming };
};

/**
 * Merge API update rows into existing grid rows. Responses are often partial; replacing
 * the whole row drops fields (e.g. expiry_date in summary_agg) and breaks tooltips until refresh.
 */
export const updatedPricerData = (newData, pricerTablesData) => {
  return pricerTablesData?.map((item) => {
    const updatedRow = newData.find((o) => o.id === item.id);
    if (!updatedRow) return item;

    const merged = { ...item, ...updatedRow };

    if (
      updatedRow.summary_agg != null &&
      typeof updatedRow.summary_agg === "object" &&
      !Array.isArray(updatedRow.summary_agg)
    ) {
      merged.summary_agg = mergeNestedObjects(item.summary_agg, updatedRow.summary_agg);
    }
    if (
      updatedRow.leg_agg != null &&
      typeof updatedRow.leg_agg === "object" &&
      !Array.isArray(updatedRow.leg_agg)
    ) {
      merged.leg_agg = mergeNestedObjects(item.leg_agg, updatedRow.leg_agg);
    }

    return merged;
  });
};
  